<form [formGroup]="form">

    <div class="flex items-center" mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
        <h2 class="headline m-0 flex-auto">Nuevo Informe</h2>

        <button class="text-secondary" mat-dialog-close mat-icon-button type="button">
            <mat-icon svgIcon="mat:close"></mat-icon>
        </button>
    </div>
    <div class="overflow-y-auto max-h-[500px]">
        <div class="flex flex-col sm:flex-row">
            <mat-form-field class="flex-auto">
                <mat-label>Nº Tracking</mat-label>
                <input formControlName="tracking" (input)="replaceTracking()" matInput>
            </mat-form-field>
            <mat-form-field class="sm:ml-6 flex-auto">
                <mat-label>Comercial</mat-label>
                <input formControlName="user" matInput>
            </mat-form-field>
            <mat-form-field class="sm:ml-6 flex-auto">
                <mat-label>Destinatario</mat-label>
                    <input type="text" matInput formControlName="receiver" placeholder="Seleccionar destinatario" [matAutocomplete]="autoContacts">
                    <mat-autocomplete #autoContacts="matAutocomplete">
                        <mat-option *ngFor="let contact of contacts" [value]="contact.email">
                           {{ contact.name }} - {{ contact.email }}
                        </mat-option>
                    </mat-autocomplete>
            </mat-form-field>

            <span class="sm:ml-6 flex items-center">
                <mat-checkbox *ngIf="this.broker.length > 0" (change)="changeReceiver($event.checked)" color="primary">Enviar a broker</mat-checkbox>
            </span>
        </div>

        <div class="bg-app-bar px-6 h-16 border-b sticky left-0 flex items-center">
            <h2 class="title my-0 ltr:pr-4 rtl:pl-4 ltr:mr-4 rtl:ml-4 ltr:border-r rtl:border-l hidden sm:block flex-none">
                <span *ngIf="selection.isEmpty()">Documentos</span>
                <span *ngIf="selection.hasValue()">{{ selection.selected.length }}
                <span *ngIf="selection.selected.length === 1">Documento</span>
                <span *ngIf="selection.selected.length > 1">Documentos</span>
                seleccionado<span *ngIf="selection.selected.length > 1">s</span></span>
            </h2>

            <div class="bg-foreground rounded-full border px-4 max-w-[300px] flex-auto flex items-center border border-gray-300">
                <mat-icon class="icon-sm text-secondary" svgIcon="mat:search"></mat-icon>
                <input [(ngModel)]="filters.search" (ngModelChange)="pageIndex=0;loadData();" [ngModelOptions]="{ standalone: true }"
                    class="px-4 py-2 border-0 outline-none w-full bg-transparent" placeholder="Buscar..." type="search">
            </div>
        </div>

        <div class="overflow-y-auto max-h-[30rem]">
            <table @stagger id="top" [dataSource]="dataSource" class="w-full" multiTemplateDataRows mat-table matSort matTableFilter 
                matSortDirection="desc" (matSortChange)="sortData($event)">

                <ng-container matColumnDef="expandIni">
                    <th class="uppercase" mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
                    <ng-container mat-cell *matCellDef="let element">
                        <td *ngIf="element.exist == true"
                            (click)="expandedElement = expandedElement === element ? null : element; loadVehicles(element,expandedElement);$event.stopPropagation()"
                            [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                            <mat-icon svgIcon="mat:keyboard_arrow_down" *ngIf="expandedElement !== element"></mat-icon>
                            <mat-icon svgIcon="mat:keyboard_arrow_up" *ngIf="expandedElement === element"></mat-icon>
                        </td>
                        <td *ngIf="element.exist == false"></td>
                    </ng-container>
                    
                </ng-container>

                <ng-container matColumnDef="checkbox">
                    <th *matHeaderCellDef mat-header-cell>
                        <mat-checkbox *ngIf="!uniqueSelect && visible"
                            (change)="$event ? masterToggle() : null"
                            [checked]="selection.hasValue() && isAllSelected()"
                            [indeterminate]="selection.hasValue() && !isAllSelected()" color="primary">
                        </mat-checkbox>
                    </th>
                    <td *matCellDef="let row" class="w-4" mat-cell>
                        <mat-checkbox (change)="$event ? selectFile(row) : null" (click)="$event.stopPropagation()"
                            [checked]="selection.isSelected(row)" color="primary" [disabled]="row.generated">
                        </mat-checkbox>
                    </td>
                </ng-container>

                <ng-container *ngFor="let column of columns; trackBy: trackByProperty">
                    <ng-container *ngIf="column.type === 'text' || column.type === 'textarea'"
                        [matColumnDef]="column.property">
                        <th *matHeaderCellDef class="uppercase" mat-header-cell mat-sort-header> {{ column.label }}</th>
                        <td *matCellDef="let row" [ngClass]="column.cssClasses" mat-cell>{{ row[column.property] }}</td>
                    </ng-container>

                    <ng-container *ngIf="column.type === 'select'" [matColumnDef]="column.property">
                        <th *matHeaderCellDef class="uppercase" mat-header-cell mat-sort-header> {{ column.label }}</th>
                        <td *matCellDef="let row" [ngClass]="column.cssClasses" mat-cell>{{ row[column.property]?.name || '' }}</td>
                    </ng-container>
                    
                    <ng-container *ngIf="column.type === 'date'" [matColumnDef]="column.property">
                        <th *matHeaderCellDef class="uppercase" mat-header-cell mat-sort-header> {{ column.label }}</th>
                        <td *matCellDef="let row" [ngClass]="column.cssClasses" mat-cell>{{ row[column.property] | date:'dd/MM/yyyy' }}</td>
                    </ng-container>

                    <ng-container *ngIf="column.type === 'number'" [matColumnDef]="column.property">
                        <th *matHeaderCellDef class="text-right uppercase" mat-header-cell> {{ column.label }}</th>
                        <td class="text-right" *matCellDef="let row"
                            [ngStyle]="{'color':getColor(row[column.property])}" mat-cell>
                            {{ row[column.property] || 0 | number:'1.0-2':'es'}} €</td>
                    </ng-container>
                    
                    <ng-container *ngIf="column.type === 'flag'" [matColumnDef]="column.property">
                        <th *matHeaderCellDef class="uppercase" mat-header-cell mat-sort-header> {{ column.label }}</th>
                        <td mat-cell *matCellDef="let row">
                            <mat-checkbox *ngIf="row.documentCategory.name == '2º LLAVE' && row.generated == false" [disabled]="row.generated"
                             color="primary" (click)="changeInsideCar(row, row[column.property])"
                             class="hover:bg-hover" [class.mat-checkbox-disabled]="false">
                            </mat-checkbox>
                        </td>
                    </ng-container>

                </ng-container>

                <ng-container matColumnDef="expandedDetail">
                    <td mat-cell *matCellDef="let element" [attr.colspan]="visibleColumns.length">
                        <div
                            *ngIf="element === expandedElement"
                            class="example-element-detail"
                            [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">

                            <table mat-table [dataSource]="vehiclesDataSource">

                                <ng-container *ngFor="let column of vehicleColumns; trackBy: trackByProperty">
                                <ng-container *ngIf="column.type === 'text' || column.type === 'textarea'" [matColumnDef]="column.property">
                                    <th mat-header-cell *matHeaderCellDef class="uppercase">{{ column.label }}</th>
                                    <td mat-cell *matCellDef="let vehicle" [ngClass]="column.cssClasses">{{ vehicle[column.property] }}</td>
                                </ng-container>

                                <ng-container *ngIf="column.type === 'select'" [matColumnDef]="column.property">
                                    <th mat-header-cell *matHeaderCellDef class="uppercase">{{ column.label }}</th>
                                    <td mat-cell *matCellDef="let vehicle" [ngClass]="column.cssClasses">{{ vehicle[column.property]?.name }}</td>
                                </ng-container>

                                <ng-container *ngIf="column.type === 'date'" [matColumnDef]="column.property">
                                    <th mat-header-cell *matHeaderCellDef class="uppercase">{{ column.label }}</th>
                                    <td mat-cell *matCellDef="let vehicle">{{ vehicle[column.property] | date: 'dd/MM/yyyy' }}</td>
                                </ng-container>

                                <ng-container *ngIf="column.type === 'vehicleSelect'" [matColumnDef]="column.property">
                                    <th mat-header-cell *matHeaderCellDef class="uppercase">{{ column.label }}</th>
                                    <td mat-cell *matCellDef="let vehicle">
                                        <mat-checkbox color="primary"
                                            [checked]="isVehicleSelected(expandedElement, vehicle)"
                                            (change)="toggleVehicle(expandedElement, vehicle, $event.checked)"
                                            (click)="$event.stopPropagation()">
                                        </mat-checkbox>
                                    </td>
                                </ng-container>

                                <ng-container *ngIf="column.type === 'vehiclePrevReport'" [matColumnDef]="column.property">
                                    <th mat-header-cell *matHeaderCellDef class="uppercase">{{ column.label }}</th>
                                    <td mat-cell *matCellDef="let vehicle">
                                        <mat-checkbox color="primary"
                                            [checked]="vehicle.inPrevReport"
                                            [disabled]="true">
                                        </mat-checkbox>
                                    </td>
                                </ng-container>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="visibleVehicleColumns"></tr>
                                <tr mat-row *matRowDef="let vehicle; columns: visibleVehicleColumns;"></tr>

                            </table>
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="visibleColumns"></tr>
                <tr @fadeInUp mat-row *matRowDef="let element; columns: visibleColumns;"
                class="example-element-row  " [class.example-expanded-row]="expandedElement === element">
                </tr>
                <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>

            </table>
        </div>
        <mat-paginator (page)="onPaginateChange($event)" showFirstLastButtons [pageSizeOptions]="pageSizeOptions"
            [pageSize]="pageSize" class="sticky left-0"></mat-paginator>

        <div class="w-full mt-6">
            <mat-form-field class="w-full">
                <mat-label class=".mat-tab-label.mat-tab-label-active">Mensaje</mat-label>
                <textarea tabindex="-1" matInput formControlName="sendMessage" rows="4">
                </textarea>
            </mat-form-field>
        </div>
    </div>

    <mat-dialog-actions align="end" class="float-right">
        <button (click)="history()" mat-flat-button>
            <mat-icon svgIcon="mat:history"></mat-icon>
            <span class="ml-1">Historial</span>
        </button>
        <button color="primary" mat-flat-button type="button" [disabled]="!form.valid || anySelect" class="m-1" (click)="export(true)">
            <mat-icon class="mr-2" svgIcon="mat:open_in_new"></mat-icon>
            <span>Previsualizar</span>
        </button>
        <button color="primary" mat-flat-button type="button" [disabled]="!form.valid || anySelect" class="m-1" (click)="export(false)">
            <mat-icon class="mr-2" svgIcon="mat:download"></mat-icon>
            <span>Descargar</span>
        </button>
        <button color="primary" mat-flat-button type="button" [disabled]="!form.valid || anySelect" class="m-1" (click)="send()">
            <mat-icon class="mr-2" svgIcon="mat:send"></mat-icon>
            <span>Enviar</span>
        </button>
    </mat-dialog-actions>
</form>